import * as React from 'react';
import {useState} from 'react';
import s from './DistributorsTree.module.css';
import style from '../../../assets/common/CommonStyle.module.css';
import fieldStyle from '../../../PersonalOffice/CreateInvoice/CreateInvoicePopup/CreateInvoicePopup.module.css';
import styleForm from '../../../PersonalOffice/RegistrationNewClient/RegistrationNewClient.module.css';
// Убрали SVG импорты - заменили на CSS градиенты
import CommonSvgSelector from '../../../assets/common/SVG/CommonSvgSelector';
import DistributorsSearchSelect from './DistributorsSearchSelect';
import {UserClient} from '../../../types/TypesUser';
import {useTranslation} from 'react-i18next';
import {useClientsByLevel} from './hook/useClientsByLevel';

type Props = {
	handleChangeUser: (client: UserClient) => void;
	closePopup: () => void;
};

const DistributorsTree = ({handleChangeUser, closePopup}: Props) => {
	const {t} = useTranslation();
	const {me, all, treeMap} = useClientsByLevel();
	const [openList, setOpenList] = useState<number[]>([]);

	const handleToggle = (id: number) => {
		setOpenList((prev) =>
			prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
		);
	};

	const renderTree = (parentId: number | null, level = 1): JSX.Element[] => {
		const key = parentId ?? 'root';
		const children = treeMap[key] || [];

		return children.map((client) => {
			const isOpen = openList.includes(client.client_id);
			const hasChildren = all.some((c) => c.parent_id === client.client_id);

			return (
				<li key={client.client_id}>
					<div className={s[`rowLevel${level}`] || s.titleRow}>
						<div className={s.clarityImg}>
							{hasChildren && (
								<button
									type="button"
									onClick={() => handleToggle(client.client_id)}
									className={s.toggleButton}
								>
									{isOpen ? (
										<div className={s.minusIcon}>−</div>
									) : (
										<div className={s.plusIcon}>+</div>
									)}
								</button>
							)}
						</div>

						{level === 1 && (
							<div className={s.green}>
								<div className={s.greenIcon}></div>
							</div>
						)}
						{level === 2 && <div className={s.greenCircle} />}
						{(level === 3 || level === 4) && <div className={s.brown} />}
						<button
							type="button"
							className={s.partnerName}
							onClick={() => handleChangeUser(client)}
						>
							{client.name} {t('Контракт')} {client.contract} {t('Рівень')}{' '}
							{client.level}
						</button>
					</div>
					{hasChildren && isOpen && (
						<ul className={s[`level${level + 1}Container`] || ''}>
							{renderTree(client.client_id, level + 1)}
						</ul>
					)}
				</li>
			);
		});
	};

	return (
		<div className={style.popupWrapper}>
			<div className={`${style.popupContainer} ${s.container}`}>
				<div className={s.closeCross}>
					<button type="button" onClick={closePopup}>
						<CommonSvgSelector id="closeCross" />
					</button>
				</div>
				<div className={fieldStyle.title}>
					<h4>{t("Дерево дистриб'юторів")}</h4>
				</div>
				<div className={s.changeClientContainer}>
					<div className={styleForm.inputName}>{t('Вибір клієнта')}</div>
					<div className={s.clientInfo_flex}>
						<div className={`${styleForm.input} ${s.changeClientInput}`}>
							<DistributorsSearchSelect
								usersList={all}
								handleChange={handleChangeUser}
							/>
						</div>
					</div>
				</div>
				<div className={s.treeContainer}>
					<div className={`${s.main}`}>
						<div className={s.avatarContainer}>
							<div className={s.avatar}>
								<img src={me.photo} alt={me?.name ?? ''} />
							</div>
						</div>
						<span className={s.name}>{me?.name}</span>
					</div>
					<ul className={s.treeRoot}>{renderTree(me?.client_id || null)}</ul>
				</div>
			</div>
		</div>
	);
};

export default DistributorsTree;
